import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';
import { useParams } from 'react-router-dom';

import { CreateInvoiceProvider } from 'packages/invoices/hooks/useCreateInvoice';
import { CreateInvoiceContainer } from 'packages/invoices/ui/create/CreateInvoiceContainer';
import { z } from 'zod/v4';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

const RouteParamsStruct = z.object({
  prefillInvoiceId: z.string().optional(),
});

// Fragments
const RouteBase = ({ prefillInvoiceId }: { prefillInvoiceId?: string }) => {
  return (
    <CreateInvoiceProvider>
      <CreateInvoiceContainer prefillInvoiceId={prefillInvoiceId} />
    </CreateInvoiceProvider>
  );
};

// Exports
export const Route = () => {
  const params = useParams();
  const { prefillInvoiceId } = RouteParamsStruct.parse(params); // a route param may exist if the user navigates to this page from canceling an existing invoice and opting to prefill a new invoice with that invoice's data

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
        height="100%"
      >
        <RouteBase prefillInvoiceId={prefillInvoiceId} />
      </Flex>
    </RouteErrorBoundary>
  );
};
